export const translations = {
  es: {
    brand: "Bevela",
    tagline: "Copropiedad de embarcaciones, sin complicaciones.",
    account: {
      title: "Mi cuenta",
      baseProfile: "Perfil Base",
      onboardingTitle: "Cuéntanos quién eres.",
      onboardingSubtitle: "Estos datos se piden una sola vez y se reutilizan en todo Bevela. Nunca te volveremos a preguntar lo mismo.",
      intentsTitle: "¿Qué quieres hacer?",
      intentsSubtitle: "Marca todo lo que te interese. Podrás activar o cambiar cualquiera de estas opciones más adelante desde Mi cuenta.",
      exploreMode: "Entrar en modo explorar",
      back: "Atrás",
      photo: "Foto de perfil",
      firstName: "Nombre", lastName: "Apellidos", phone: "Teléfono de contacto",
      city: "Ciudad de residencia", region: "Provincia / región", secondResidence: "Segunda residencia (opcional)",
      zones: "Zona náutica de interés", portPlaceholder: "Puerto habitual (opcional): Dénia, Marina Botafoc…",
      experience: "Experiencia náutica", license: "Titulación",
      expLevels: { none: "Sin experiencia", basic: "Básico", intermediate: "Intermedio", advanced: "Avanzado" },
      identity: { none: "Identidad no verificada", pending: "Verificación en revisión", verified: "Identidad verificada" },
      complete: "completado", edit: "Editar", cancel: "Cancelar", save: "Guardar", saved: "Guardado",
      required: "Faltan campos obligatorios",
      extensions: "Mis extensiones", wantAlso: "Quiero también…",
      noRepeat: "Solo te pediremos lo que aún no sabemos de ti. Tus datos del Perfil Base se reutilizan automáticamente.",
      activate: "Activar →", completeIt: "Completar →", view: "Ver / editar →",
      extension: "Extensión", saveDraft: "Guardar borrador", draftSaved: "Borrador guardado", update: "Actualizar",
      activated: "Extensión activada", sentReview: "Enviado a revisión. Te avisaremos en menos de 48 h.",
      pendingNote: "Tu solicitud está en revisión por el equipo de Bevela. Te avisaremos cuando esté verificada.",
      rejectedNote: "Motivo del rechazo", reviewInfo: "Esta extensión requiere verificación manual de titularidad/documentación antes de activarse.",
      invitations: "Invitaciones recibidas", invitedCoowner: "te ha invitado como copropietario/a de su barco.",
      invitedGroup: "te ha invitado a su grupo de compra.", accept: "Aceptar", invitationAccepted: "Invitación aceptada",
      dashExt: "Tus perfiles activos", dashExtEmpty: "Aún no has activado ninguna extensión. Elige qué quieres hacer en Bevela.",
      verifyEmail: "Verifica tu email para desbloquear todas las funciones.", resend: "Reenviar email",
    },
    meta: {
      "/": ["Bevela — Copropiedad náutica gestionada en España", "Compra una participación real de un barco y deja que Bevela gestione amarre, mantenimiento, seguros y calendario. Tú solo decides cuándo navegar."],
      "/explorar": ["Explorar embarcaciones | Bevela", "Descubre la flota seleccionada de Bevela: veleros, motoras y catamaranes disponibles en copropiedad en Baleares, Costa Blanca y más."],
      "/login": ["Iniciar sesión | Bevela", "Accede a tu cuenta de Bevela para gestionar tu barco, tus días de navegación y tu perfil."],
      "/registro": ["Crear cuenta | Bevela", "Regístrate en Bevela y empieza a buscar tu barco en copropiedad gestionada."],
      "/recuperar": ["Recuperar contraseña | Bevela", "Restablece el acceso a tu cuenta de Bevela."],
      "/reset-password": ["Nueva contraseña | Bevela", "Define una nueva contraseña para tu cuenta de Bevela."],
      "/onboarding": ["Completa tu perfil | Bevela", "Cuéntanos cómo quieres disfrutar del mar para adaptar Bevela a ti."],
      "/dashboard": ["Mi panel | Bevela", "Tu resumen de Bevela: barcos, solicitudes y próximos pasos."],
      "/perfil": ["Mi perfil | Bevela", "Gestiona tus datos personales y preferencias náuticas en Bevela."],
      "/mis-embarcaciones": ["Mis embarcaciones | Bevela", "Gestiona las embarcaciones que has registrado en Bevela."],
      "/sobre-nosotros": ["Sobre nosotros | Bevela", "Conoce al equipo detrás de Bevela y por qué creemos en otra forma de ser propietario de un barco."],
      "/faq": ["Preguntas frecuentes | Bevela", "Respuestas sobre copropiedad, reparto de días por puntos, averías, seguros y salida de una participación."],
      "/aviso-legal": ["Aviso legal | Bevela", "Información legal sobre el titular de bevela.es y las condiciones de uso del sitio."],
      "/privacidad": ["Política de privacidad | Bevela", "Cómo trata Bevela tus datos personales conforme al RGPD y la LOPDGDD."],
      "/cookies": ["Política de cookies | Bevela", "Qué cookies usa bevela.es y cómo puedes gestionarlas."],
      boatDetail: ["Detalle de embarcación | Bevela", "Ficha completa de la embarcación: características, puerto y participaciones disponibles."],
    },
    footer: {
      company: "Empresa",
      legal: "Legal",
      contact: "Contacto",
      about: "Sobre nosotros",
      faq: "Preguntas frecuentes",
      explore: "Explorar la flota",
      legalNotice: "Aviso legal",
      privacy: "Política de privacidad",
      cookies: "Política de cookies",
      whatsapp: "Escríbenos por WhatsApp",
      rights: "Todos los derechos reservados.",
    },
    cookies: {
      text: "Usamos cookies técnicas imprescindibles y, solo si lo aceptas, cookies analíticas para mejorar Bevela.",
      more: "Más información",
      accept: "Aceptar todas",
      reject: "Solo necesarias",
    },
    contactStrip: {
      eyebrow: "Hablemos",
      title: "¿Tienes dudas? Una persona real te responde.",
      body: "Sin bots ni formularios eternos. Escríbenos y te contestamos en menos de 24 horas laborables.",
      call: "Llamar",
      email: "Escribir un email",
      whatsapp: "WhatsApp",
    },
    social: {
      eyebrow: "Lo que dicen nuestros copropietarios",
      title: "Propietarios reales. Días reales en el mar.",
      items: [
        { quote: "Llevaba años queriendo un barco y nunca me salían los números. Con Bevela navego 25 días al año y no he pisado un taller.", name: "Carlos M.", role: "Copropietario · Dénia" },
        { quote: "Lo que más valoro es el calendario. Sé exactamente qué días son míos y no discuto con nadie por el puente de agosto.", name: "Laura G.", role: "Copropietaria · Ibiza" },
        { quote: "Puse mi barco en gestión con Bevela y por primera vez el amarre no me cuesta dinero: los días que no lo uso, se alquila.", name: "Javier R.", role: "Propietario · Jávea" },
      ],
      pressLabel: "Han hablado de nosotros",
      press: ["Náutica & Yates", "Expansión", "El Confidencial", "Skipper"],
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Lo que todo futuro copropietario nos pregunta.",
      viewAll: "Ver todas las preguntas",
      items: [
        { q: "¿Cómo salgo o vendo mi participación?", a: "Tu participación es tuya y puedes venderla cuando quieras. Publicas la venta desde tu panel, Bevela busca comprador entre los perfiles compatibles (o entre los demás copropietarios, que tienen prioridad) y nuestro equipo acompaña la operación hasta el cierre." },
        { q: "¿Cómo se reparten los días? El sistema de puntos", a: "Cada copropietario recibe 100 puntos al año. Cada día tiene un coste en puntos según la demanda (de 1 en temporada baja a 4 en las semanas más solicitadas). Reservas desde el calendario compartido y el saldo se descuenta al instante. Nadie se lleva todo el verano: la asignación inicial limita a 7 días consecutivos de alta demanda." },
        { q: "¿Qué pasa si hay una avería grande?", a: "Bevela gestiona la reparación con proveedores homologados y te informa en el panel con presupuesto, fechas y documentación. Los costes ordinarios están cubiertos por la cuota de gestión; los extraordinarios se reparten proporcionalmente a la participación, siempre con aprobación previa." },
        { q: "¿Quién gestiona el seguro?", a: "Bevela contrata y renueva el seguro a todo riesgo del barco y la responsabilidad civil. La póliza y los recibos están siempre disponibles en la sección Documentación de tu panel." },
        { q: "¿Puedo venir con mi propio grupo?", a: "Sí. Si ya tenéis claro con quién queréis compartir el barco, invitas a cada persona por email y cada una completa su perfil. Si vienes solo, buscamos perfiles compatibles según zona, uso y presupuesto." },
        { q: "¿Y si ya tengo un barco y solo quiero que me lo gestionéis?", a: "También es posible. Das de alta tu barco, verificamos la titularidad y eliges qué servicios contratar: mantenimiento, limpieza, seguros, documentación, calendario o alquiler de los días que no usas." },
      ],
    },
    about: {
      eyebrow: "Sobre nosotros",
      title: "Nacimos en el Mediterráneo con una idea sencilla: un barco debería darte días en el mar, no facturas.",
      body1: "Bevela nace en la Costa Blanca, entre Jávea, Dénia e Ibiza, de la experiencia de propietarios que veían sus barcos parados 340 días al año mientras seguían pagando amarre, seguros y revisiones.",
      body2: "Creemos que la copropiedad bien gestionada es la forma más inteligente de tener un barco: propiedad real, uso organizado y una operativa profesional que se ocupa de todo lo que no es navegar.",
      valuesTitle: "Cómo trabajamos",
      values: [
        { h: "Transparencia total", p: "Cada gasto, cada servicio y cada día de uso queda registrado y visible para todos los copropietarios." },
        { h: "Gestión profesional", p: "Trabajamos con astilleros, marinas y proveedores homologados. El barco siempre está listo para salir." },
        { h: "Personas antes que anuncios", p: "No somos un marketplace de checkout. Detrás de cada operación hay una reunión con nuestro equipo." },
      ],
      teamTitle: "El equipo",
      team: [
        { name: "Pablo Moreno", role: "Fundador & CEO", bio: "Patrón de yate y emprendedor. Más de 15 años navegando por Baleares y la Costa Blanca." },
        { name: "Equipo de operaciones", role: "Gestión náutica", bio: "Mantenimiento, amarres, seguros y documentación. Las personas que hacen que el barco esté siempre listo." },
        { name: "Equipo de copropietarios", role: "Atención y matching", bio: "Te acompañan desde la primera llamada hasta la firma, y después." },
      ],
    },
    whyBevela: {
      metaTitle: "Por qué Bevela — Copropiedad de barcos en el Mediterráneo",
      metaDesc: "Qué es Bevela, qué problema resuelve la copropiedad, ventajas, cómo funciona, servicios para propietarios y quiénes somos.",
      hero: {
        eyebrow: "Por qué Bevela",
        title: "Disfruta del mar sin cargar con el barco entero.",
        subtitle: "Bevela hace posible tener barco de verdad —usándolo, no manteniéndolo— compartiendo propiedad, costes y gestión con personas afines.",
      },
      why: {
        anchorTitle: "Por qué Bevela",
        what: { h: "Qué es Bevela", p: "Bevela es una plataforma de copropiedad de embarcaciones. Conectamos a personas que quieren disfrutar de un barco en el Mediterráneo y lo compartimos en participaciones —normalmente cuatro—, con toda la gestión resuelta por nosotros." },
        problem: { h: "Qué problema resuelve", p: "Un barco en España pasa de media más de 340 días al año amarrado. Comprarlo entero significa pagar el 100% de la inversión, el amarre y el mantenimiento para usarlo unas pocas semanas. Bevela elimina ese desperdicio." },
        coownership: { h: "Por qué tiene sentido la copropiedad", p: "Pagas solo por la parte que usas. Divides la inversión y los gastos fijos entre varios copropietarios, mantienes el acceso a un barco mejor del que comprarías en solitario y olvidas lo tedioso: mantenimiento, seguros, amarre y logística." },
        advantages: {
          h: "Ventajas de hacerlo con Bevela",
          items: [
            "Inversión y costes divididos entre copropietarios.",
            "Barco siempre listo: mantenimiento, seguro y amarre gestionados.",
            "Calendario de uso justo y transparente entre copropietarios.",
            "Copropietarios verificados y afines a tu zona y forma de navegar.",
            "Acompañamiento humano de Bevela en cada paso, dentro y fuera de la plataforma.",
          ],
        },
        how: {
          h: "Cómo funciona",
          steps: [
            { t: "Explora", d: "Descubre embarcaciones por zona y precio de participación, con recomendaciones según tu perfil." },
            { t: "Muestra interés", d: "Pulsa 'Me interesa' en el barco que encaja contigo. Guardamos tu interés de forma privada." },
            { t: "Compatibilidad", d: "Cruzamos zona y presupuesto para detectar coincidencias entre interesados y embarcaciones." },
            { t: "Bevela te acompaña", d: "Nuestro equipo contacta contigo para cerrar la copropiedad de forma segura y sin prisas." },
          ],
        },
      },
      owners: {
        anchorTitle: "Para propietarios",
        intro: { h: "¿Ya tienes un barco?", p: "Si eres propietario, Bevela te ayuda a rentabilizarlo y a quitarte de encima la gestión. Puedes abrir tu barco a copropiedad o, simplemente, delegar en nosotros su gestión integral." },
        items: [
          { h: "Gestión integral", p: "Nos ocupamos de la operativa completa del barco para que tú solo tengas que navegar." },
          { h: "Mantenimiento", p: "Revisiones, reparaciones y puesta a punto coordinadas con profesionales de confianza." },
          { h: "Calendario compartido", p: "Reparto de fechas claro y equitativo entre copropietarios, sin conflictos." },
          { h: "Servicios náuticos", p: "Amarre, seguro, limpieza, invernaje y extras resueltos desde un único sitio." },
          { h: "Gestión de copropietarios", p: "Selección, verificación y coordinación de las personas que comparten el barco." },
          { h: "Transparencia de costes", p: "Cada gasto documentado y repartido; sabes siempre en qué se invierte." },
        ],
        cta: "Habla con Bevela",
      },
      about: {
        anchorTitle: "Quiénes somos",
        philosophy: { h: "Nuestra filosofía", p: "Personas antes que anuncios. Creemos en una náutica más accesible, transparente y compartida, donde disfrutar del mar no dependa de asumir el peso de un barco entero." },
        project: { h: "El proyecto", p: "Bevela nace en el Mediterráneo para transformar la propiedad náutica en una experiencia compartida, profesional y sin fricciones. Empezamos generando encuentros entre personas afines y barcos que encajan, y acompañamos cada operación de principio a fin." },
      },
      faqTitle: "Preguntas frecuentes",
    },
    nav: {
      home: "Inicio",
      explore: "Explorar",
      myBoats: "Mis embarcaciones",
      manage: "Gestión",
      profile: "Mi perfil",
      login: "Iniciar sesión",
      register: "Registrarse",
      logout: "Cerrar sesión",
      why: "Por qué Bevela",
      access: "Acceder",
      whyItems: {
        why: { label: "Por qué Bevela", desc: "Qué es, qué resuelve y cómo funciona" },
        owners: { label: "Para propietarios", desc: "Gestión integral si ya tienes barco" },
        about: { label: "Quiénes somos", desc: "Historia, equipo, filosofía y proyecto" },
        faq: { label: "Preguntas frecuentes", desc: "Todo lo que necesitas saber" },
      },
    },
    landing: {
      eyebrow: "Copropiedad náutica gestionada",
      concept: {
        eyebrow: "El concepto",
        title: "Una forma más inteligente de disfrutar del mar.",
        body1: "Ser propietario de un barco no debería significar renunciar a disfrutarlo ni cargar con todo lo que implica tenerlo.",
        body2: "Bevela crea otra forma: propiedad real, gestión integral y una comunidad de copropietarios que comparte algo más que un barco.",
        signature: "Bevela. Vívela.",
      },
      hero: {
        title: "Tu barco. Sin 342 días muerto en el amarre.",
        subtitle: "Con Bevela compartes la propiedad de un barco sin compartir sus complicaciones. Nos ocupamos del calendario, el amarre, el mantenimiento, la limpieza y la gestión del día a día. Tú solo tienes que decidir cuándo quieres navegar.",
      },
      stat: {
        number: "93%",
        line1: "del tiempo, parado.",
        body: "La media de uso real de un barco de recreo en España es de apenas 2–4 semanas al año. El resto del tiempo permanece en el amarre mientras siguen corriendo el mantenimiento, los seguros, las revisiones y las facturas.",
        outro1: "Un barco debería darte días en el mar.",
        outro2: "No meses en el amarre.",
      },
      fleet: {
        eyebrow: "Embarcaciones",
        title: "Descubre tu próximo barco.",
        subtitle: "Embarcaciones seleccionadas para disfrutar del mar como propietario.",
        cta: "Explora",
        ctaSecondary: "Ver toda la flota",
      },
      what: {
        eyebrow: "Qué hace Bevela",
        title: "Todo lo que implica ser propietario. Sin tener que ocuparte de todo.",
        subtitle: "Ser propietario de un barco debería empezar cuando sales a navegar. Bevela se ocupa de todo lo que sucede cuando tú no estás navegando.",
        steps: [
          { k: "01", h: "Las personas adecuadas", p: "Encontramos copropietarios que encajan según su perfil de uso y preferencias. Si ya tienes tu grupo, podéis venir juntos." },
          { k: "02", h: "Gestión integral", p: "Amarre, mantenimiento, seguros, limpieza, revisiones, documentación y calendario. El barco siempre cuidado. Tú no tienes que coordinarlo." },
          { k: "03", h: "Cuando tú no lo usas", p: "Los días que decides no navegar, Bevela puede gestionar el barco y aprovechar esos días. Tú decides cuándo disfrutarlo. Nosotros nos ocupamos del resto." },
          { k: "04", h: "Todo desde tu pantalla", p: "Consulta desde la plataforma tus usos, reservas, mantenimiento, revisiones, documentación y evolución del barco. Toda la información. En un solo lugar." },
        ],
      },
      how: {
        eyebrow: "Cómo funciona",
        title: "Compartes la propiedad. Nosotros hacemos que compartirla sea fácil.",
        steps: [
          { k: "01", h: "Elige tu embarcación", p: "Explora las embarcaciones seleccionadas por Bevela o incorpora la tuya." },
          { k: "02", h: "Forma tu grupo", p: "Incorpórate a un grupo existente o ven con el tuyo. Si vienes solo, Bevela busca perfiles compatibles según necesidades de uso y fechas preferentes." },
          { k: "03", h: "Disfruta de tu barco", p: "Tu participación te da acceso a la embarcación mediante un sistema de uso organizado y equilibrado." },
          { k: "04", h: "Nosotros gestionamos el resto", p: "Calendario, limpieza, mantenimiento, varada y gestión operativa. Menos coordinación. Más tiempo en el mar." },
        ],
      },
      ways: {
        eyebrow: "Formas de disfrutarlo",
        privateTag: "100% Privado",
        privateTitle: "Máxima privacidad. Cero gestión.",
        privateBody: "Para quienes quieren disfrutar de sus días exclusivamente para uso privado.",
        hybridTag: "Híbrido",
        hybridTitle: "Navega cuando quieras. Aprovecha el resto.",
        hybridBody: "Para quienes quieren disfrutar del barco y aprovechar los días que no utilizan. Cuando no navegues, Bevela puede gestionar esos días y generar ingresos para ti.",
      },
      compare: {
        eyebrow: "Comparativa",
        title: "¿Y si tu barco te pagase los días que no lo usas?",
        subtitle: "Compara alquilar, comprar y ser propietario con Bevela.",
        example: "D29 · Dénia · 200.000 € · 4 copropietarios",
        cols: ["Alquilar", "Comprar 100%", "Bevela · 25%"],
        rows: [
          ["Propiedad", "0%", "100%", "25% · 50.000 €"],
          ["Entrada", "0 €", "60.000 €", "15.000 €"],
          ["Financiación / año", "—", "18.650 €", "4.660 €"],
          ["Amarre + mantenimiento + seguro", "—", "18.000 €", "4.500 €"],
          ["Coste de alquilar", "18.000 €", "—", "—"],
          ["Coste anual", "18.000 €", "36.650 €", "9.160 €"],
          ["Ingresos por días no usados", "—", "—", "−7.500 €"],
        ],
        totalLabel: "Coste efectivo anual",
        totalValues: ["18.000 €", "36.650 €", "1.660 €"],
        keyTitle: "La clave",
        keyBody1: "Tu 25% te da días propios de navegación mediante el sistema de puntos.",
        keyBody2: "Los días que no utilizas pueden alquilarse y generar ingresos para ti.",
        keyBody3: "9.160 € de coste − 7.500 € de ingresos = 1.660 € de coste efectivo anual.",
        keyBody4: "Y sigues siendo propietario del 25% de un barco valorado en 200.000 €.",
        ctaEyebrow: "Tu barco. Tus días. Tus ingresos.",
        cta: "Calcula tu escenario",
        disclaimer: "Ejemplo orientativo para un D29 en Dénia. Financiación estimada del 70% a 10 años al 6%. El ingreso de 7.500 € corresponde a 10 días alquilados por el propietario a 750 €/día. Los ingresos están sujetos a demanda, disponibilidad y condiciones de explotación. Los costes indicados son estimaciones.",
      },
      close: {
        eyebrow: "Da el primer paso",
        title: "Tu próximo verano puede empezar con una llamada.",
        line1: "Cuéntanos cómo quieres navegar y te proponemos barco, zona y copropietarios compatibles.",
        line2: "Sin compromiso. Sin checkout. Una conversación con nuestro equipo.",
        signature: "Bevela. Vívela.",
      },
      cta: "Comenzar",
      ctaSecondary: "Ya tengo cuenta",
      video: {
        eyebrow: "El momento",
        title: "Tu barco.",
        title2: "Cuando tú quieras.",
      },
      interest: {
        title: "Me interesa este barco",
        subtitle: "Déjanos tus datos y te contactamos en las próximas 24 horas.",
        fullName: "Nombre y apellidos",
        phone: "Teléfono",
        email: "Email",
        postalCode: "Código postal",
        comments: "Comentarios (opcional)",
        send: "Enviar solicitud",
        cancel: "Cancelar",
        or: "o",
        registerInstead: "prefiero registrarme",
        sentTitle: "Solicitud recibida",
        sentBody: "Gracias. Nuestro equipo te contactará en menos de 24 horas.",
        close: "Cerrar",
      },
    },
    auth: {
      loginTitle: "Bienvenido de vuelta",
      loginSubtitle: "Accede a tu bitácora de Bevela.",
      registerTitle: "Crea tu cuenta",
      registerSubtitle: "Empieza a diseñar tu experiencia náutica.",
      forgotTitle: "Recuperar contraseña",
      forgotSubtitle: "Introduce tu email y te enviaremos un enlace de restablecimiento.",
      resetTitle: "Nueva contraseña",
      firstName: "Nombre",
      lastName: "Apellidos",
      email: "Email",
      phone: "Teléfono",
      password: "Contraseña",
      newPassword: "Nueva contraseña",
      forgotLink: "¿Olvidaste tu contraseña?",
      noAccount: "¿No tienes cuenta?",
      haveAccount: "¿Ya tienes cuenta?",
      signIn: "Iniciar sesión",
      signUp: "Crear cuenta",
      send: "Enviar",
      resetSent: "Enlace generado. Revisa tu email o utiliza el enlace mostrado.",
      simulatedEmailNote: "Modo demo: el email no se envía. Utiliza el enlace mostrado.",
      openLink: "Abrir enlace",
    },
    onboarding: {
      title: "Cuéntanos qué buscas",
      subtitle: "Adaptaremos tu experiencia. Podrás cambiarlo cuando quieras.",
      owner: "Quiero ser copropietario",
      ownerDesc: "Me interesa adquirir una participación en una embarcación.",
      boat_owner: "Tengo una embarcación",
      boat_ownerDesc: "Quiero incorporar mi barco a Bevela para compartir su coste.",
      both: "Ambas",
      bothDesc: "Estoy interesado en las dos opciones.",
      continue: "Continuar",
    },
    dashboard: {
      hello: "Hola",
      yourProfile: "Tu perfil",
      complete: "completado",
      completeProfile: "Completar perfil",
      myBoats: "Mis embarcaciones",
      addBoat: "+ Añadir embarcación",
      comingSoon: "Próximamente",
      matchingSoon: "Encontraremos embarcaciones y propietarios compatibles con tu perfil.",
      noBoats: "Aún no has añadido ninguna embarcación.",
    },
    profile: {
      title: "Mi perfil",
      personal: "Datos personales",
      preferences: "Preferencias de embarcación",
      usage: "Preferencias de uso",
      country: "País",
      city: "Ciudad",
      language: "Idioma",
      userType: "Tipo de usuario",
      save: "Guardar cambios",
      saved: "Cambios guardados",
      boatTypes: "Tipos de embarcación",
      minLength: "Eslora mínima (m)",
      maxLength: "Eslora máxima (m)",
      preferredLocations: "Zonas de navegación preferidas",
      preferredPort: "Puerto / zona preferida",
      maxBudget: "Presupuesto máximo (€)",
      annualUsageDays: "Días de uso al año",
      preferredMonths: "Meses preferidos",
      usageModel: "Modelo de uso",
      usageModels: { private: "Privado", hybrid: "Híbrido", profitability: "Orientado a rentabilidad" },
    },
    explore: {
      title: "Explorar la flota",
      hero: "La flota curada de Bevela",
      heroSubtitle: "Embarcaciones seleccionadas por su estado, ubicación y potencial de copropiedad. Explora libremente — regístrate solo cuando quieras dar el siguiente paso.",
      searchPlaceholder: "Marca, modelo, puerto…",
      filters: "Filtros",
      type: "Tipo",
      allTypes: "Todos",
      minLength: "Eslora mínima (m)",
      maxLength: "Eslora máxima (m)",
      country: "País",
      location: "Zona",
      minSharePrice: "Precio mín. participación (€)",
      maxSharePrice: "Precio máx. participación (€)",
      sort: "Ordenar",
      sortRecent: "Más recientes",
      sortPriceAsc: "Precio: menor a mayor",
      sortPriceDesc: "Precio: mayor a menor",
      sortLengthDesc: "Eslora: mayor a menor",
      results: "resultados",
      noResults: "No hay embarcaciones que coincidan con tus filtros.",
      clearFilters: "Limpiar filtros",
      sharePrice: "Precio por 25%",
      viewBoat: "Ver embarcación",
      interested: "Me interesa",
      loginToContinue: "Regístrate o inicia sesión para continuar.",
      backToFleet: "Volver a la flota",
      soon: "Próximamente",
      body: "Estamos preparando el sistema que encontrará la embarcación y los propietarios que mejor encajan contigo.",
      recommendedTitle: "Recomendados para ti",
      recommendedSubtitle: "Barcos que encajan con tu zona y tu presupuesto.",
      outOfBudgetTitle: "Ligeramente fuera de presupuesto",
      outOfBudgetTag: "Fuera de presupuesto",
      reasonZoneBudget: "En tu zona y dentro de tu presupuesto",
      reasonZone: "En tu zona",
      reasonBudget: "Dentro de tu presupuesto",
      reasonOther: "Sugerido para ti",
      interestedActive: "Ya te interesa",
      removeInterest: "Quitar interés",
      interestSavedTitle: "Interés registrado",
      interestSavedBody: "Hemos registrado tu interés. El equipo de Bevela revisará la compatibilidad y te contactará para dar el siguiente paso.",
      modalityCoownership: "Copropiedad",
      modalityFull: "Compra completa",
    },
    boats: {
      title: "Mis embarcaciones",
      add: "Añadir embarcación",
      view: "Ver embarcación",
      edit: "Editar",
      delete: "Eliminar",
      confirmDelete: "¿Eliminar esta embarcación? Esta acción no se puede deshacer.",
      newTitle: "Nueva embarcación",
      editTitle: "Editar embarcación",
      status: { draft: "Borrador", active: "Activa", reserved: "Reservada", sold: "Vendida", inactive: "Inactiva" },
      listing: { unlisted: "No publicada", pending_review: "En revisión", published: "Publicada en Explora", rejected: "Publicación rechazada" },
      listingLabel: "Publicación en Explora",
      ownershipMode: "Modalidad",
      ownershipModes: { coownership: "Copropiedad", full: "Compra completa" },
      section: {
        basic: "Datos básicos",
        location: "Ubicación",
        economic: "Información económica",
        condition: "Estado",
        photos: "Fotografías",
        ownership: "Copropiedad",
      },
      f: {
        brand: "Marca", model: "Modelo", year: "Año", type: "Tipo",
        length: "Eslora (m)", beam: "Manga (m)", capacity: "Plazas", engine: "Motor / Potencia",
        country: "País", location: "Zona", port: "Puerto",
        estimatedValue: "Valor estimado (€)", annualCost: "Costes anuales (€)",
        mooringCost: "Coste de amarre (€)", otherCosts: "Otros costes (€)",
        generalCondition: "Estado general", lastMaintenance: "Último mantenimiento",
        nextMaintenance: "Próximo mantenimiento", description: "Información adicional",
        status: "Estado",
      },
      types: { sailboat: "Velero", motor: "Motor", catamaran: "Catamarán", other: "Otro" },
      conditions: { excellent: "Excelente", good: "Bueno", fair: "Correcto", needs_improvements: "Necesita mejoras" },
      ownership: {
        title: "Configuración de copropiedad",
        standard: "Modelo estándar Bevela",
        standardDesc: "4 copropietarios × 25% cada uno",
        boatValue: "Valor embarcación",
        owners: "Nº copropietarios",
        percentage: "% individual",
        sharePrice: "Precio por participación",
        different: "¿Quieres una distribución diferente?",
        consult: "Consultar con Bevela",
        consultTitle: "Solicitar distribución personalizada",
        desiredOwners: "Nº copropietarios deseado",
        distribution: "Distribución en mente",
        comments: "Comentarios",
        contactEmail: "Email de contacto",
        sendRequest: "Enviar solicitud",
        requestSent: "Solicitud enviada. Nuestro equipo la revisará.",
      },
      save: "Guardar embarcación",
      saveDraft: "Guardar como borrador",
      saveChanges: "Guardar cambios",
      requestPublish: "Solicitar publicación en Explora",
      publishRequested: "Solicitud de publicación enviada. Bevela la revisará.",
      publishInfo: "Registrar tu embarcación NO la publica en Explora. Solicita la publicación y el equipo de Bevela la revisará antes de hacerla pública.",
      photos: {
        upload: "Subir fotografías",
        drag: "Arrastra tus fotos o haz clic para seleccionar",
        primary: "Principal",
        markPrimary: "Marcar como principal",
        remove: "Eliminar",
        formats: "JPG, PNG, WEBP · Máx 8MB",
      },
      created: "Embarcación creada",
      updated: "Embarcación actualizada",
      deleted: "Embarcación eliminada",
    },
  },
  en: {
    brand: "Bevela",
    tagline: "Fractional boat ownership, done right.",
    account: {
      title: "My account",
      baseProfile: "Base profile",
      onboardingTitle: "Tell us who you are.",
      onboardingSubtitle: "We ask for this once and reuse it across Bevela. We'll never ask you the same thing twice.",
      intentsTitle: "What do you want to do?",
      intentsSubtitle: "Pick everything you're interested in. You can activate or change any of these later from My account.",
      exploreMode: "Enter explore mode",
      back: "Back",
      photo: "Profile photo",
      firstName: "First name", lastName: "Last name", phone: "Contact phone",
      city: "City of residence", region: "Province / region", secondResidence: "Second residence (optional)",
      zones: "Nautical area of interest", portPlaceholder: "Usual port (optional): Dénia, Marina Botafoc…",
      experience: "Sailing experience", license: "Licence",
      expLevels: { none: "No experience", basic: "Basic", intermediate: "Intermediate", advanced: "Advanced" },
      identity: { none: "Identity not verified", pending: "Verification under review", verified: "Identity verified" },
      complete: "complete", edit: "Edit", cancel: "Cancel", save: "Save", saved: "Saved",
      required: "Required fields missing",
      extensions: "My extensions", wantAlso: "I also want to…",
      noRepeat: "We only ask what we don't know yet. Your base profile is reused automatically.",
      activate: "Activate →", completeIt: "Complete →", view: "View / edit →",
      extension: "Extension", saveDraft: "Save draft", draftSaved: "Draft saved", update: "Update",
      activated: "Extension activated", sentReview: "Sent for review. We'll get back within 48h.",
      pendingNote: "Your request is being reviewed by the Bevela team.",
      rejectedNote: "Rejection reason", reviewInfo: "This extension requires manual verification before activation.",
      invitations: "Invitations received", invitedCoowner: "invited you as co-owner of their boat.",
      invitedGroup: "invited you to their buying group.", accept: "Accept", invitationAccepted: "Invitation accepted",
      dashExt: "Your active profiles", dashExtEmpty: "You haven't activated any extension yet. Choose what you want to do on Bevela.",
      verifyEmail: "Verify your email to unlock all features.", resend: "Resend email",
    },
    meta: {
      "/": ["Bevela — Managed fractional boat ownership in Spain", "Buy a real share of a boat and let Bevela handle mooring, maintenance, insurance and the calendar. You only decide when to sail."],
      "/explorar": ["Explore boats | Bevela", "Discover Bevela's curated fleet: sailboats, motor yachts and catamarans available for co-ownership in the Balearics, Costa Blanca and beyond."],
      "/login": ["Sign in | Bevela", "Access your Bevela account to manage your boat, sailing days and profile."],
      "/registro": ["Create account | Bevela", "Join Bevela and start looking for your managed co-owned boat."],
      "/recuperar": ["Reset password | Bevela", "Recover access to your Bevela account."],
      "/reset-password": ["New password | Bevela", "Set a new password for your Bevela account."],
      "/onboarding": ["Complete your profile | Bevela", "Tell us how you want to enjoy the sea so Bevela adapts to you."],
      "/dashboard": ["My dashboard | Bevela", "Your Bevela overview: boats, requests and next steps."],
      "/perfil": ["My profile | Bevela", "Manage your personal details and nautical preferences."],
      "/mis-embarcaciones": ["My boats | Bevela", "Manage the boats you have registered on Bevela."],
      "/sobre-nosotros": ["About us | Bevela", "Meet the team behind Bevela and why we believe in another way to own a boat."],
      "/faq": ["FAQ | Bevela", "Answers about co-ownership, points-based day sharing, breakdowns, insurance and exiting a share."],
      "/aviso-legal": ["Legal notice | Bevela", "Legal information about the owner of bevela.es and terms of use."],
      "/privacidad": ["Privacy policy | Bevela", "How Bevela processes your personal data under GDPR."],
      "/cookies": ["Cookie policy | Bevela", "Which cookies bevela.es uses and how to manage them."],
      boatDetail: ["Boat details | Bevela", "Full boat listing: specs, port and available shares."],
    },
    footer: {
      company: "Company",
      legal: "Legal",
      contact: "Contact",
      about: "About us",
      faq: "FAQ",
      explore: "Explore the fleet",
      legalNotice: "Legal notice",
      privacy: "Privacy policy",
      cookies: "Cookie policy",
      whatsapp: "Message us on WhatsApp",
      rights: "All rights reserved.",
    },
    cookies: {
      text: "We use essential cookies and, only with your consent, analytics cookies to improve Bevela.",
      more: "Learn more",
      accept: "Accept all",
      reject: "Essential only",
    },
    contactStrip: {
      eyebrow: "Let's talk",
      title: "Questions? A real person answers.",
      body: "No bots, no endless forms. Write to us and we reply within one business day.",
      call: "Call",
      email: "Send an email",
      whatsapp: "WhatsApp",
    },
    social: {
      eyebrow: "What our co-owners say",
      title: "Real owners. Real days at sea.",
      items: [
        { quote: "I'd wanted a boat for years and the numbers never worked. With Bevela I sail 25 days a year and have never set foot in a boatyard.", name: "Carlos M.", role: "Co-owner · Dénia" },
        { quote: "What I value most is the calendar. I know exactly which days are mine and never argue over the August bank holiday.", name: "Laura G.", role: "Co-owner · Ibiza" },
        { quote: "I put my boat under Bevela management and for the first time the mooring doesn't cost me money: the days I don't use it, it's rented.", name: "Javier R.", role: "Owner · Jávea" },
      ],
      pressLabel: "Featured in",
      press: ["Náutica & Yates", "Expansión", "El Confidencial", "Skipper"],
    },
    faq: {
      eyebrow: "FAQ",
      title: "What every future co-owner asks us.",
      viewAll: "See all questions",
      items: [
        { q: "How do I exit or sell my share?", a: "Your share is yours and you can sell it whenever you want. You list it from your dashboard, Bevela finds a buyer among compatible profiles (the other co-owners have priority) and our team accompanies the deal to closing." },
        { q: "How are days shared? The points system", a: "Each co-owner gets 100 points per year. Each day costs points depending on demand (from 1 in low season to 4 in the most requested weeks). You book from the shared calendar and the balance updates instantly. Nobody takes the whole summer: the initial allocation caps high-demand stays at 7 consecutive days." },
        { q: "What if there is a major breakdown?", a: "Bevela manages the repair with approved providers and keeps you informed in the dashboard with quote, dates and documents. Ordinary costs are covered by the management fee; extraordinary ones are split by share, always with prior approval." },
        { q: "Who manages the insurance?", a: "Bevela arranges and renews the boat's comprehensive and liability insurance. The policy and receipts are always available in the Documents section of your dashboard." },
        { q: "Can I come with my own group?", a: "Yes. If you already know who you want to share with, invite each person by email and they complete their profile. If you come alone, we find compatible profiles by area, usage and budget." },
        { q: "I already own a boat — can you just manage it?", a: "Absolutely. Register your boat, we verify ownership and you choose the services: maintenance, cleaning, insurance, paperwork, calendar or renting out the days you don't use." },
      ],
    },
    about: {
      eyebrow: "About us",
      title: "Born in the Mediterranean with a simple idea: a boat should give you days at sea, not invoices.",
      body1: "Bevela was born on the Costa Blanca, between Jávea, Dénia and Ibiza, from owners who watched their boats sit idle 340 days a year while still paying mooring, insurance and servicing.",
      body2: "We believe well-managed co-ownership is the smartest way to own a boat: real ownership, organised use and a professional operation that handles everything that isn't sailing.",
      valuesTitle: "How we work",
      values: [
        { h: "Full transparency", p: "Every expense, service and day of use is logged and visible to all co-owners." },
        { h: "Professional management", p: "We work with approved yards, marinas and providers. The boat is always ready to go." },
        { h: "People before listings", p: "We're not a checkout marketplace. Behind every deal there's a meeting with our team." },
      ],
      teamTitle: "The team",
      team: [
        { name: "Pablo Moreno", role: "Founder & CEO", bio: "Yachtmaster and entrepreneur. 15+ years sailing the Balearics and Costa Blanca." },
        { name: "Operations team", role: "Nautical management", bio: "Maintenance, moorings, insurance and paperwork. The people who keep the boat ready." },
        { name: "Co-owner team", role: "Care & matching", bio: "With you from the first call to signing, and beyond." },
      ],
    },
    whyBevela: {
      metaTitle: "Why Bevela — Boat co-ownership in the Mediterranean",
      metaDesc: "What Bevela is, the problem co-ownership solves, advantages, how it works, owner services and who we are.",
      hero: {
        eyebrow: "Why Bevela",
        title: "Enjoy the sea without carrying the whole boat.",
        subtitle: "Bevela makes it possible to truly own a boat —using it, not maintaining it— sharing ownership, costs and management with like-minded people.",
      },
      why: {
        anchorTitle: "Why Bevela",
        what: { h: "What Bevela is", p: "Bevela is a boat co-ownership platform. We connect people who want to enjoy a boat in the Mediterranean and share it in shares —usually four—, with all the management handled by us." },
        problem: { h: "The problem it solves", p: "A boat in Spain sits moored more than 340 days a year on average. Buying it whole means paying 100% of the investment, mooring and maintenance to use it just a few weeks. Bevela removes that waste." },
        coownership: { h: "Why co-ownership makes sense", p: "You only pay for the part you use. You split the investment and fixed costs across several co-owners, keep access to a better boat than you'd buy alone, and forget the tedious part: maintenance, insurance, mooring and logistics." },
        advantages: {
          h: "Advantages of doing it with Bevela",
          items: [
            "Investment and costs split among co-owners.",
            "Boat always ready: maintenance, insurance and mooring handled.",
            "A fair, transparent usage calendar among co-owners.",
            "Verified co-owners aligned with your area and way of sailing.",
            "Human support from Bevela at every step, on and off the platform.",
          ],
        },
        how: {
          h: "How it works",
          steps: [
            { t: "Explore", d: "Discover boats by area and share price, with recommendations based on your profile." },
            { t: "Show interest", d: "Tap 'I'm interested' on the boat that fits you. We save your interest privately." },
            { t: "Compatibility", d: "We match area and budget to detect coincidences between people and boats." },
            { t: "Bevela guides you", d: "Our team contacts you to close the co-ownership safely and without rush." },
          ],
        },
      },
      owners: {
        anchorTitle: "For owners",
        intro: { h: "Already own a boat?", p: "If you're an owner, Bevela helps you make it profitable and take management off your hands. You can open your boat to co-ownership or simply delegate its full management to us." },
        items: [
          { h: "Full management", p: "We handle the boat's complete operation so you only have to sail." },
          { h: "Maintenance", p: "Inspections, repairs and tune-ups coordinated with trusted professionals." },
          { h: "Shared calendar", p: "A clear, fair split of dates among co-owners, with no conflicts." },
          { h: "Nautical services", p: "Mooring, insurance, cleaning, wintering and extras solved from one place." },
          { h: "Co-owner management", p: "Selection, verification and coordination of the people sharing the boat." },
          { h: "Cost transparency", p: "Every expense documented and split; you always know where it goes." },
        ],
        cta: "Talk to Bevela",
      },
      about: {
        anchorTitle: "Who we are",
        philosophy: { h: "Our philosophy", p: "People before listings. We believe in a more accessible, transparent and shared boating, where enjoying the sea doesn't depend on carrying the weight of a whole boat." },
        project: { h: "The project", p: "Bevela was born in the Mediterranean to turn boat ownership into a shared, professional and frictionless experience. We start by matching like-minded people with the right boats, and we guide every operation from start to finish." },
      },
      faqTitle: "Frequently asked questions",
    },
    nav: {
      home: "Home",
      explore: "Explore",
      myBoats: "My boats",
      manage: "Management",
      profile: "My profile",
      login: "Sign in",
      register: "Sign up",
      logout: "Sign out",
      why: "Why Bevela",
      access: "Access",
      whyItems: {
        why: { label: "Why Bevela", desc: "What it is, what it solves and how it works" },
        owners: { label: "For owners", desc: "Full management if you already own a boat" },
        about: { label: "Who we are", desc: "Story, team, philosophy and project" },
        faq: { label: "FAQ", desc: "Everything you need to know" },
      },
    },
    landing: {
      eyebrow: "Managed fractional boat ownership",
      concept: {
        eyebrow: "The concept",
        title: "A smarter way to enjoy the sea.",
        body1: "Owning a boat shouldn't mean giving up on enjoying it or carrying the full weight of it.",
        body2: "Bevela is a new way in: real ownership, full management, and a community of co-owners that share more than a boat.",
        signature: "Bevela. Live it.",
      },
      hero: {
        title: "Your boat. Without 342 days idle at the dock.",
        subtitle: "With Bevela you share the ownership of a boat, not its complications. We handle the calendar, mooring, maintenance, cleaning and day-to-day operations. You only decide when you want to sail.",
      },
      stat: {
        number: "93%",
        line1: "of the time, idle.",
        body: "The average recreational boat in Spain is used just 2 to 4 weeks a year. The rest of the time it sits at the dock while maintenance, insurance, refits and bills keep running.",
        outro1: "A boat should give you days at sea.",
        outro2: "Not months at the dock.",
      },
      fleet: {
        eyebrow: "Boats",
        title: "Discover your next boat.",
        subtitle: "Boats hand-picked to enjoy the sea as an owner.",
        cta: "Explore",
        ctaSecondary: "See the full fleet",
      },
      what: {
        eyebrow: "What Bevela does",
        title: "Everything ownership involves. Without you having to run any of it.",
        subtitle: "Owning a boat should start when you set sail. Bevela takes care of everything that happens when you're not sailing.",
        steps: [
          { k: "01", h: "The right people", p: "We find co-owners that fit based on usage profile and preferences. If you already have your group, you can join together." },
          { k: "02", h: "Full management", p: "Mooring, maintenance, insurance, cleaning, inspections, documentation and calendar. The boat, always cared for. You never have to coordinate it." },
          { k: "03", h: "When you're not using it", p: "On the days you decide not to sail, Bevela can manage the boat and put those days to work. You choose when to enjoy it. We take care of the rest." },
          { k: "04", h: "All from your screen", p: "Track your usage, bookings, maintenance, inspections, documentation and the boat's evolution — all in one place." },
        ],
      },
      how: {
        eyebrow: "How it works",
        title: "You share ownership. We make sharing it easy.",
        steps: [
          { k: "01", h: "Choose your boat", p: "Explore the boats selected by Bevela or bring in your own." },
          { k: "02", h: "Form your group", p: "Join an existing group or come with yours. If you come solo, Bevela finds compatible profiles by usage needs and preferred dates." },
          { k: "03", h: "Enjoy your boat", p: "Your share gives you access to the boat through an organized, balanced usage system." },
          { k: "04", h: "We handle the rest", p: "Calendar, cleaning, maintenance, hauling and operations. Less coordination. More time at sea." },
        ],
      },
      ways: {
        eyebrow: "Ways to enjoy it",
        privateTag: "100% Private",
        privateTitle: "Maximum privacy. Zero management.",
        privateBody: "For those who want their days exclusively for private use.",
        hybridTag: "Hybrid",
        hybridTitle: "Sail whenever you want. Monetize the rest.",
        hybridBody: "For those who want to enjoy the boat and put the days they don't use to work. When you're not sailing, Bevela can manage those days and generate income for you.",
      },
      compare: {
        eyebrow: "Comparison",
        title: "What if your boat paid for the days you don't use it?",
        subtitle: "Compare renting, buying and co-owning with Bevela.",
        example: "D29 · Dénia · €200,000 · 4 co-owners",
        cols: ["Rent", "Buy 100%", "Bevela · 25%"],
        rows: [
          ["Ownership", "0%", "100%", "25% · €50,000"],
          ["Down payment", "€0", "€60,000", "€15,000"],
          ["Financing / year", "—", "€18,650", "€4,660"],
          ["Mooring + maintenance + insurance", "—", "€18,000", "€4,500"],
          ["Rental cost", "€18,000", "—", "—"],
          ["Annual cost", "€18,000", "€36,650", "€9,160"],
          ["Income from unused days", "—", "—", "−€7,500"],
        ],
        totalLabel: "Effective annual cost",
        totalValues: ["€18,000", "€36,650", "€1,660"],
        keyTitle: "The key",
        keyBody1: "Your 25% gives you sailing days through the points system.",
        keyBody2: "Unused days can be rented and generate income for you.",
        keyBody3: "€9,160 cost − €7,500 income = €1,660 effective annual cost.",
        keyBody4: "And you still own 25% of a boat valued at €200,000.",
        ctaEyebrow: "Your boat. Your days. Your income.",
        cta: "Run your scenario",
        disclaimer: "Illustrative example for a D29 in Dénia. Estimated 70% financing over 10 years at 6%. The €7,500 income assumes 10 days rented by the owner at €750/day. Income is subject to demand, availability and operating conditions. Costs shown are estimates.",
      },
      close: {
        eyebrow: "Take the first step",
        title: "Your next summer can start with a call.",
        line1: "Tell us how you want to sail and we'll propose a boat, an area and compatible co-owners.",
        line2: "No commitment. No checkout. A conversation with our team.",
        signature: "Bevela. Live it.",
      },
      cta: "Get started",
      ctaSecondary: "I already have an account",
      video: {
        eyebrow: "The moment",
        title: "Your boat.",
        title2: "Whenever you want.",
      },
      interest: {
        title: "I'm interested in this boat",
        subtitle: "Leave your details and we'll contact you within 24 hours.",
        fullName: "Full name",
        phone: "Phone",
        email: "Email",
        postalCode: "Postal code",
        comments: "Comments (optional)",
        send: "Send request",
        cancel: "Cancel",
        or: "or",
        registerInstead: "I'd rather sign up",
        sentTitle: "Request received",
        sentBody: "Thanks. Our team will contact you within 24 hours.",
        close: "Close",
      },
    },
    auth: {
      loginTitle: "Welcome back",
      loginSubtitle: "Access your Bevela logbook.",
      registerTitle: "Create your account",
      registerSubtitle: "Start designing your nautical experience.",
      forgotTitle: "Recover password",
      forgotSubtitle: "Enter your email and we'll send you a reset link.",
      resetTitle: "New password",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      password: "Password",
      newPassword: "New password",
      forgotLink: "Forgot your password?",
      noAccount: "Don't have an account?",
      haveAccount: "Already have an account?",
      signIn: "Sign in",
      signUp: "Sign up",
      send: "Send",
      resetSent: "Link generated. Check your email or use the link shown.",
      simulatedEmailNote: "Demo mode: no email is sent. Use the link below.",
      openLink: "Open link",
    },
    onboarding: {
      title: "Tell us what you're looking for",
      subtitle: "We'll tailor your experience. You can change this anytime.",
      owner: "I want to be a co-owner",
      ownerDesc: "I'm interested in buying a share of a boat.",
      boat_owner: "I own a boat",
      boat_ownerDesc: "I want to list mine on Bevela to share its cost.",
      both: "Both",
      bothDesc: "I'm interested in both options.",
      continue: "Continue",
    },
    dashboard: {
      hello: "Hello",
      yourProfile: "Your profile",
      complete: "complete",
      completeProfile: "Complete profile",
      myBoats: "My boats",
      addBoat: "+ Add boat",
      comingSoon: "Coming soon",
      matchingSoon: "We'll find boats and co-owners that match your profile.",
      noBoats: "You haven't added any boats yet.",
    },
    profile: {
      title: "My profile",
      personal: "Personal data",
      preferences: "Boat preferences",
      usage: "Usage preferences",
      country: "Country",
      city: "City",
      language: "Language",
      userType: "User type",
      save: "Save changes",
      saved: "Changes saved",
      boatTypes: "Boat types",
      minLength: "Min length (m)",
      maxLength: "Max length (m)",
      preferredLocations: "Preferred sailing areas",
      preferredPort: "Preferred port / area",
      maxBudget: "Max budget (€)",
      annualUsageDays: "Days of use per year",
      preferredMonths: "Preferred months",
      usageModel: "Usage model",
      usageModels: { private: "Private", hybrid: "Hybrid", profitability: "Profitability-oriented" },
    },
    explore: {
      title: "Explore the fleet",
      hero: "Bevela's curated fleet",
      heroSubtitle: "Boats hand-picked for their condition, location and co-ownership potential. Browse freely — sign up only when you want to move forward.",
      searchPlaceholder: "Brand, model, port…",
      filters: "Filters",
      type: "Type",
      allTypes: "All",
      minLength: "Min length (m)",
      maxLength: "Max length (m)",
      country: "Country",
      location: "Area",
      minSharePrice: "Min share price (€)",
      maxSharePrice: "Max share price (€)",
      sort: "Sort",
      sortRecent: "Most recent",
      sortPriceAsc: "Price: low to high",
      sortPriceDesc: "Price: high to low",
      sortLengthDesc: "Length: longest first",
      results: "results",
      noResults: "No boats match your filters.",
      clearFilters: "Clear filters",
      sharePrice: "Price per 25%",
      viewBoat: "View boat",
      interested: "I'm interested",
      loginToContinue: "Sign in or sign up to continue.",
      backToFleet: "Back to fleet",
      soon: "Coming soon",
      body: "We're preparing the system that will find the boat and the co-owners that best match you.",
      recommendedTitle: "Recommended for you",
      recommendedSubtitle: "Boats that match your area and budget.",
      outOfBudgetTitle: "Slightly over budget",
      outOfBudgetTag: "Over budget",
      reasonZoneBudget: "In your area and within budget",
      reasonZone: "In your area",
      reasonBudget: "Within your budget",
      reasonOther: "Suggested for you",
      interestedActive: "You're interested",
      removeInterest: "Remove interest",
      interestSavedTitle: "Interest saved",
      interestSavedBody: "We've saved your interest. The Bevela team will review compatibility and contact you to take the next step.",
      modalityCoownership: "Co-ownership",
      modalityFull: "Full purchase",
    },
    boats: {
      title: "My boats",
      add: "Add boat",
      view: "View boat",
      edit: "Edit",
      delete: "Delete",
      confirmDelete: "Delete this boat? This cannot be undone.",
      newTitle: "New boat",
      editTitle: "Edit boat",
      status: { draft: "Draft", active: "Active", reserved: "Reserved", sold: "Sold", inactive: "Inactive" },
      listing: { unlisted: "Not listed", pending_review: "Under review", published: "Listed on Explora", rejected: "Listing rejected" },
      listingLabel: "Explora listing",
      ownershipMode: "Ownership mode",
      ownershipModes: { coownership: "Co-ownership", full: "Full purchase" },
      section: {
        basic: "Basic data",
        location: "Location",
        economic: "Financial info",
        condition: "Condition",
        photos: "Photos",
        ownership: "Co-ownership",
      },
      f: {
        brand: "Brand", model: "Model", year: "Year", type: "Type",
        length: "Length (m)", beam: "Beam (m)", capacity: "Capacity", engine: "Engine / Power",
        country: "Country", location: "Area", port: "Port",
        estimatedValue: "Estimated value (€)", annualCost: "Annual costs (€)",
        mooringCost: "Mooring cost (€)", otherCosts: "Other costs (€)",
        generalCondition: "General condition", lastMaintenance: "Last maintenance",
        nextMaintenance: "Next maintenance", description: "Additional information",
        status: "Status",
      },
      types: { sailboat: "Sailboat", motor: "Motor", catamaran: "Catamaran", other: "Other" },
      conditions: { excellent: "Excellent", good: "Good", fair: "Fair", needs_improvements: "Needs improvements" },
      ownership: {
        title: "Co-ownership configuration",
        standard: "Standard Bevela model",
        standardDesc: "4 co-owners × 25% each",
        boatValue: "Boat value",
        owners: "Co-owners",
        percentage: "Individual %",
        sharePrice: "Share price",
        different: "Want a different distribution?",
        consult: "Consult with Bevela",
        consultTitle: "Request custom distribution",
        desiredOwners: "Desired number of co-owners",
        distribution: "Distribution in mind",
        comments: "Comments",
        contactEmail: "Contact email",
        sendRequest: "Send request",
        requestSent: "Request sent. Our team will review it.",
      },
      save: "Save boat",
      saveDraft: "Save as draft",
      saveChanges: "Save changes",
      requestPublish: "Request Explora listing",
      publishRequested: "Listing request sent. Bevela will review it.",
      publishInfo: "Registering your boat does NOT list it on Explora. Request a listing and the Bevela team will review it before making it public.",
      photos: {
        upload: "Upload photos",
        drag: "Drag your photos or click to select",
        primary: "Primary",
        markPrimary: "Mark as primary",
        remove: "Remove",
        formats: "JPG, PNG, WEBP · Max 8MB",
      },
      created: "Boat created",
      updated: "Boat updated",
      deleted: "Boat deleted",
    },
  },
};
